var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 55,
    viewBox: "0 0 66 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3796 29.4398C65.3796 22.9398 60.3096 17.1998 52.9596 14.3398C53.3396 15.6798 53.5296 17.1098 53.5296 18.5498C53.5296 30.3998 40.4296 39.9598 24.3796 39.9598C24.0896 39.9598 23.8996 39.8598 23.8096 39.8598C28.0196 43.8698 34.6096 46.4498 42.0696 46.4498C44.3696 46.4498 46.5596 46.1598 48.6696 45.7798L61.1896 54.3798L55.3596 43.3898C61.4796 40.3298 65.3996 35.2598 65.3996 29.4298L65.3796 29.4398Z",
    fill: "#6E6F74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.66 36.13C22.27 36.13 19.88 35.84 17.68 35.36L4.49 44.54L10.51 32.88C4.21 29.63 0 24.28 0 18.06C0 8.13 10.99 0 24.66 0C38.33 0 49.23 8.13 49.23 18.06C49.23 27.99 38.23 36.13 24.66 36.13Z",
    fill: "#3671B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.385 23.49L24.6908 29.3596L10 9.02724L17.9635 9L28.385 23.49Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3906 9L33.7605 15.033L37.4116 9H29.3906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVChat);
export default __webpack_public_path__ + "static/media/vChat.c7115026867de8f5a42b722f6d427608.svg";
export { ForwardRef as ReactComponent };